// Arabic → English city names, for surfaces a Chinese supplier reads.
//
// profiles.city is free text and mostly Arabic for traders: production today
// holds جدة, الرياض, الخبر, القصيم and الرس alongside Latin "Riyadh" and
// "Dammam". The public RFQ page is English and aimed at factories in China, so
// "Registered Buyer — جدة" is unreadable to its entire audience.
//
// THE FALLBACK IS TO HIDE, NEVER TO PASS THROUGH. An unmapped Arabic value
// returns '' and the caller drops the city, because a line of Arabic script on
// that page is worse than no city at all — it tells the reader nothing and
// makes the page look broken. A Latin value is returned as typed.

// Keys are normalised (see normalise below), so one entry covers the common
// spelling drift: ة/ه, أ/إ/آ/ا, ى/ي, and an optional ال- prefix.
const AR_TO_EN = {
  'رياض': 'Riyadh',
  'جده': 'Jeddah',
  'دمام': 'Dammam',
  'خبر': 'Khobar',
  'ظهران': 'Dhahran',
  'قطيف': 'Qatif',
  'جبيل': 'Jubail',
  'احساء': 'Al-Ahsa',
  'هفوف': 'Hofuf',
  'قصيم': 'Al-Qassim',
  'بريده': 'Buraydah',
  'رس': 'Ar Rass',
  'عنيزه': 'Unayzah',
  'مكه': 'Makkah',
  'مكه المكرمه': 'Makkah',
  'مدينه': 'Madinah',
  'مدينه المنوره': 'Madinah',
  'طايف': 'Taif',
  'ينبع': 'Yanbu',
  'تبوك': 'Tabuk',
  'حايل': 'Hail',
  'ابها': 'Abha',
  'خميس مشيط': 'Khamis Mushait',
  'نجران': 'Najran',
  'جازان': 'Jazan',
  'باحه': 'Al-Bahah',
  'بيشه': 'Bisha',
  'حفر الباطن': 'Hafar Al-Batin',
  'عرعر': 'Arar',
  'سكاكا': 'Sakaka',
  'جوف': 'Al-Jouf',
  'خرج': 'Al-Kharj',
  'مجمعه': 'Al-Majmaah',
  'زلفي': 'Az Zulfi',
  'شرقيه': 'Eastern Province',
};

const ARABIC_SCRIPT = /[؀-ۿ]/;

function normalise(raw) {
  return String(raw || '')
    .trim()
    .replace(/[ً-ْ]/g, '')   // harakat
    .replace(/[أإآ]/g, 'ا')
    .replace(/ة/g, 'ه')
    .replace(/ى/g, 'ي')
    .replace(/ـ/g, '')            // tatweel
    .replace(/^ال/, '')                // definite article: الرياض → رياض
    .replace(/\s+/g, ' ')
    .toLowerCase();
}

// Returns an English city name, or '' when the caller should show nothing.
export function cityInEnglish(raw) {
  const value = String(raw || '').trim();
  if (!value) return '';

  if (!ARABIC_SCRIPT.test(value)) {
    // Already Latin (or Chinese, for a supplier surface) — pass through as typed.
    return value;
  }

  return AR_TO_EN[normalise(value)] || '';
}

// Exported for the test, so the map and the normaliser can be checked against
// the values actually sitting in production rather than an invented list.
export const __AR_TO_EN = AR_TO_EN;
